module.exports = "<link href=\"https://fonts.googleapis.com/css?family=Roboto:300,400,500\" type=\"text/css\" rel=\"stylesheet\">\r\n<router-outlet></router-outlet>\r\n<app-cookies></app-cookies>\r\n<!-- <app-trophy-bar></app-trophy-bar> -->\r\n<app-alert></app-alert>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main